import { PERMISSIONS } from '@/generated/permissions'

// -----------------------------------------------------------------------------
// SIDE NAV CONFIG
// -----------------------------------------------------------------------------
export const SIDE_NAV_ENABLED = true
export const SIDE_NAV_OPTIONS = [
  {
    children: [],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-view-dashboard',
      to: { path: '/' },
    },
    requiresAuth: true,
    title: 'Dashboard',
    value: 'dashboard',
  },
  {
    children: [
      {
        anyPerm: [PERMISSIONS.SETTINGS_NOTIFICATIONS_MANAGE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-cog-outline',
          to: { path: '/admin/settings' },
        },
        requiresAuth: true,
        title: 'Settings',
        value: 'admin-settings',
      },
      {
        anyPerm: [PERMISSIONS.ADMIN_USERS_MANAGE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-account-cog-outline',
          to: { path: '/admin/user-roles' },
        },
        requiresAuth: true,
        title: 'User Roles',
        value: 'admin-user-roles',
      },
      {
        anyPerm: [PERMISSIONS.AUDIT_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-clipboard-text-search-outline',
          to: { path: '/admin/audit-logs' },
        },
        requiresAuth: true,
        title: 'Audit Logs',
        value: 'admin-audit-logs',
      },
    ],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-shield-account',
    },
    requiresAuth: true,
    title: 'Admin',
    value: 'admin',
  },
  {
    type: 'divider',
  },
  {
    children: [
      {
        anyPerm: [PERMISSIONS.VENDOR_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-truck-delivery-outline',
          to: { path: '/vendors' },
        },
        requiresAuth: true,
        title: 'Vendors',
        value: 'vendors',
      },
      {
        anyPerm: [PERMISSIONS.CONTRACTOR_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-account-hard-hat',
          to: { path: '/contractors' },
        },
        requiresAuth: true,
        title: 'Contractors',
        value: 'contractors',
      },
      {
        anyPerm: [PERMISSIONS.CONTRACTOR_APPROVE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-clipboard-check-outline',
          to: { path: '/admin/contractor-approvals' },
        },
        requiresAuth: true,
        title: 'Contractor Time Sheets',
        value: 'contractor-approvals',
      },
      // {
      //   title: 'Request Overtime',
      //   value: 'overtime-request',
      //   props: {
      //     prependIcon: 'mdi-timer-plus-outline',
      //     to: { path: '/overtime-request' },
      //   },
      //   developerOnly: false,
      //   children: [],
      //   requiresAuth: true,
      // },
      {
        anyPerm: [PERMISSIONS.OVERTIME_REVIEW],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-timer-check-outline',
          to: { path: '/admin/overtime-requests' },
        },
        requiresAuth: true,
        title: 'Overtime Requests',
        value: 'overtime-requests-admin',
      },
    ],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-briefcase-outline',
    },
    requiresAuth: true,
    title: 'Operations',
    value: 'operations',
  },
  // {
  //   type: 'divider',
  // },
  {
    children: [
      {
        anyPerm: [
          PERMISSIONS.CUSTOMER_READ,
          PERMISSIONS.CUSTOMER_CREATE,
          PERMISSIONS.CUSTOMER_UPDATE,
        ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-account-group',
          to: { path: '/customers' },
        },
        requiresAuth: true,
        title: 'Customers',
        value: 'customers',
      },
      {
        anyPerm: [
          PERMISSIONS.ESTIMATE_READ,
          PERMISSIONS.ESTIMATE_CREATE,
          PERMISSIONS.ESTIMATE_UPDATE,
          PERMISSIONS.ESTIMATE_DELETE,
          PERMISSIONS.ESTIMATE_SEND,
        ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-file-document-multiple',
          to: { path: '/estimates' },
        },
        requiresAuth: true,
        title: 'Estimates',
        value: 'estimates',
      },
      {
        anyPerm: [PERMISSIONS.INVOICE_READ, PERMISSIONS.INVOICE_UPDATE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-receipt-text-outline',
          to: { path: '/invoices' },
        },
        requiresAuth: true,
        title: 'Invoices',
        value: 'invoices',
      },
    ],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-calculator-variant-outline',
    },
    requiresAuth: true,
    title: 'Accounting',
    value: 'accounting',
  },
  // {
  //   type: 'divider',
  // },
  {
    children: [
      {
        anyPerm: [PERMISSIONS.PROJECT_STARTER_MANAGE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-folder-plus-outline',
          to: { path: '/project-starter' },
        },
        requiresAuth: true,
        title: 'Project Starter',
        value: 'project-starter',
      },
      {
        anyPerm: [PERMISSIONS.PROJECT_NAMER_MANAGE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-folder-edit-outline',
          to: { path: '/project-namer' },
        },
        requiresAuth: true,
        title: 'App Name Generator',
        value: 'project-namer',
      },
      {
        anyPerm: [PERMISSIONS.PROJECT_NAMER_MANAGE],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-routes',
          to: { path: '/mqtt-topic-generator' },
        },
        requiresAuth: true,
        title: 'MQTT Topic Generator',
        value: 'mqtt-topic-generator',
      },
    ],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-folder-cog-outline',
    },
    requiresAuth: true,
    title: 'Projects',
    value: 'projects',
  },
  {
    type: 'divider',
  },
  {
    children: [
      {
        anyPerm: [PERMISSIONS.CLEANER_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-account-multiple',
          to: { path: '/cleaning/cleaners' },
        },
        requiresAuth: true,
        title: 'Cleaners',
        value: 'cleaning-cleaners',
      },
      {
        anyPerm: [PERMISSIONS.CATALOG_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-format-list-bulleted-square',
          to: { path: '/cleaning/catalog' },
        },
        requiresAuth: true,
        title: 'Item Catalog',
        value: 'cleaning-catalog',
      },
      {
        anyPerm: [PERMISSIONS.REQUEST_READ],
        children: [],
        developerOnly: false,
        props: {
          prependIcon: 'mdi-clipboard-list-outline',
          to: { path: '/cleaning/requests' },
        },
        requiresAuth: true,
        title: 'Supply Requests',
        value: 'cleaning-requests',
      },
    ],
    developerOnly: false,
    props: {
      prependIcon: 'mdi-spray-bottle',
    },
    requiresAuth: true,
    title: 'Cleaning',
    value: 'cleaning',
  },
]

// -----------------------------------------------------------------------------
// BOTTOM NAV CONFIG
// -----------------------------------------------------------------------------
export const BOTTOM_NAV_ENABLED = false
export const BOTTOM_NAV_OPTIONS = []
